import React, { useState, useContext, useRef, useEffect } from "react";
import { useHistory, useRouteMatch, Link, useParams } from "react-router-dom";
import AppContext from "../../../Context/AppContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import useScroll from "../../../hooks/useScroll";
import LoaderLogo from "../../../Components/Assets/img/loader.png";
import "./Login.css";
import {QA} from "../../../config";

const Login = () => {
  const { login, checkUserSession, activeCount, changeLoading } =
    useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [typeLogin, setTypeLogin] = useState(1);
  const [txtEmail, setTxtEmail] = useState("");
  const [errorLogin, seterrorLogin] = useState({
    severity: 0,
    visible: 0,
    message: "",
  });
  const history = useHistory();
  const match = useRouteMatch("/login");
  const form = useRef(null);
  const { webAlias } = useParams();
  const [blockScroll, allowScroll] = useScroll();
  const handleLogin = async (event) => {
    changeLoading(true);
    event.preventDefault();

    const formData = new FormData(form.current);
    const email = formData.get("email");
    const password = formData.get("password");
    const userStep = await login(email, password, typeLogin);
    if (userStep === true) {
      history.push("/Inicio");
      changeLoading(false);
    } else {
      changeLoading(false);
      console.log(userStep.data);
      const MySwal = withReactContent(Swal);
      await MySwal.fire({
        title: <strong>Error al iniciar sesión!</strong>,
        html: <i> {userStep.data} .</i>,
        icon: "error",
      });
    }
  };
  const LoginR = (
    <div className="columnas">
      <div className="col-1-login"></div>
      <div className="col-2-login">
        {errorLogin.visible === 1 && (
          <section
            className={`modalMessageLogin modalMessageLoginServerity${errorLogin.severity}`}
          >
            <div className="btnCloseMessage__Message">{errorLogin.message}</div>
            <div
              aria-hidden="true"
              aria-label="Close Modal"
              className="btnClosMessage__container "
              onClick={() => seterrorLogin({ visible: 0 })}
            ></div>
          </section>
        )}

        <div clasName="col-login-1"></div>
        <form clasName="form-login " ref={form} onSubmit={handleLogin}>
          <div className="fv-row mb-10 form-top">
            <img className="imgLogoLogin" src={LoaderLogo} alt="Gestores Logo" />
            <h1 className="heading-1 titulo-login"> {QA && ( <strong>CALIDAD<br/></strong>)}Iniciar sesión </h1>

            <label className="form-label fs-6 fw-bolder text-dark">
              Email o Clave de Gestor
            </label>
            <input
              className="form-control  form-control-solid"
              name="email"
              onChange={(input) => setTxtEmail(input.value)}
              required
            />
          </div>
          <div className="fv-row mb-10">
            <div className="d-flex flex-stack mb-2">
              <label className="form-label fw-bolder text-dark fs-6 mb-0">
                Contraseña
              </label>
            </div>
            <input
              className="form-control form-control-solid"
              type="password"
              name="password"
              placeholder="Password"
              required
            />
          </div>
          <div className="text-center fv-row mb-10">
            <button
              type="submit"
              className="btn btn-lg btn-primary   form-control-lg w-100 mb-5"
            >
              Ingresar
            </button>
          </div>
        </form>
      </div>
      <div className="col-3-login"></div>
    </div>
  );
  return LoginR;
};

export default Login;
